import * as palette from "./palette";

export { palette };
